import { faqWidgetStyles } from "@iewc/Widgets/VerndaleBox/FaqWidget";

faqWidgetStyles.title = {
    variant: "h2",
};
